import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';

import { MatDialog } from "@angular/material/dialog";

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { ExcelService } from 'src/app/service/utilitarios/excel.service';
import { MaeUsuarioService } from 'src/app/service/mae-usuario.service';

import { MaeUsuarioM,MaeUsuarioE } from 'src/app/model/mae-usuario-bean';
import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { ComboM } from 'src/app/model/combo-bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { EstadoDml } from 'src/app/model/estadoDml';

import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';

@Component({
  selector: 'app-dml-usuario',
  templateUrl: './dml-usuario.component.html',
  styleUrls: ['./dml-usuario.component.scss']
})
export class DmlUsuarioComponent implements OnInit {

  constructor(
    private maeUsuarioService:MaeUsuarioService,
    private maeTablaService:MaeTablaService,
    private excelService:ExcelService,
    private utilitarioService:UtilitarioService,
    private modalService: MDBModalService,
    private globalVariablesService: GlobalVariablesService,
    private dialogo: MatDialog,
    public  modalRefUsuarioDml: MDBModalRef,
  ) { }

    //variables enviado desde el padre
  id:String;
  x_titulo:String;
  x_proceso:String;
  editUser:boolean;
  esSuperAdmin:boolean;

  //filtro
  listOrgano= new Array<Mae_tabla_E>();
  listPerfil= new Array<Mae_tabla_E>();
  listEstado= new Array<Mae_tabla_E>();

  maeUsuarioE = new MaeUsuarioE();

  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();

  ngOnInit(): void {
    this.esSuperAdmin = (this.globalVariablesService.getC_perfil() == "35");

    this.cargarDatoInicial(this.x_proceso);
  }

  cargarDatoInicial(dml:String){

    this.utilitarioService.loading = true;

    const cargarOrgano = this.maeTablaService.getList("OFICINA").toPromise()
    .then(result => {
      this.listOrgano = result;
    });

    const cargarPerfil = this.maeTablaService.getList("PERFIL").toPromise()
    .then(result => {
      this.listPerfil = result;
      console.log(!this.esSuperAdmin);
      console.log(!this.editUser);
      console.log( this.listPerfil.length);
      if(!this.esSuperAdmin && this.editUser && this.listPerfil.length>0)
        this.maeUsuarioE.c_perfil = 1;
    });

    const cargarEstado = this.maeTablaService.getList("ESTADO_REGISTRO").toPromise()
    .then(result => {
      this.listEstado = result;
    });

    if (dml=='I'){

      this.maeUsuarioE.c_oficina = 0;
      this.maeUsuarioE.c_perfil = 0;
      this.maeUsuarioE.c_estado = 0;

      Promise.all([cargarOrgano,cargarPerfil,cargarEstado])
      .then(response => {
        this.utilitarioService.loading = false;
      })
      .catch(error => console.log(`Error in executing ${error}`));

    }

    if (dml=='U'){

      const cargarUsuario = this.maeUsuarioService.getUser(this.id.toString(),"1").toPromise()
      .then(result => {
        this.maeUsuarioE = result[0];
      });

      Promise.all([cargarOrgano,cargarPerfil,cargarEstado,cargarUsuario])
      .then(response => {
        this.utilitarioService.loading = false;
      })
      .catch(error => console.log(`Error in executing ${error}`));
    }

  }

  onGrabar(){

    if (this.validarFormulario()==false){
      return false;
    }

    this.utilitarioService.loading=true;

    //this.maeUsuarioE.c_doc_identidad = 1; //dni
    this.maeUsuarioE.serviceCredencialesM = this.globalVariablesService.getCredencialesConvenio();
    this.maeUsuarioE.auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio(this.x_proceso);
    console.log(this.maeUsuarioE);

    if(this.x_proceso=='I')
      this.maeUsuarioService.insert(this.maeUsuarioE).subscribe((response_dml_bean:Response_dml_bean)=>{
        //console.log(this.x_proceso);
        this.utilitarioService.loading=false;

        if(response_dml_bean.codigoRespuestaServicio=="1"){
          this.onClosemodal();
          this.action.next(response_dml_bean);
        }
        else
          this.utilitarioService.toastrError(response_dml_bean.mensaje);
      },
      error=>{
        this.utilitarioService.loading=false;
        console.log(error);
        this.utilitarioService.toastrError(error.error.messages.toString())
      });

    else

      this.maeUsuarioService.update(this.maeUsuarioE).subscribe((response_dml_bean:Response_dml_bean)=>{
        //console.log(this.x_proceso);
        this.utilitarioService.loading=false;
        this.onClosemodal();
        this.action.next(response_dml_bean);
      },
      error=>{
        this.utilitarioService.loading=false;
        console.log(error);
        this.utilitarioService.toastrError(error.error.messages.toString())
      });
  }

  onClosemodal(){
    this.modalRefUsuarioDml.hide();
  }

  validarFormulario() : Boolean{
    //valida formulario
    if (this.globalVariablesService.getC_usuario.toString()==null){
      this.utilitarioService.toastrError("Su sesion ha culminado, ingrese nuevamente al sistema.");
      return false;
    }

    //validar datos convenios
    if (this.maeUsuarioE.x_usuario=="" || this.maeUsuarioE.x_usuario==null){
      this.utilitarioService.toastrError("Ingrese el correo.");
      return false;
    }

    if (this.maeUsuarioE.x_nro_documento=="" || this.maeUsuarioE.x_nro_documento==null){
      this.utilitarioService.toastrError("Ingrese el nro. de documento.");
      return false;
    }

    if (this.maeUsuarioE.x_nombres=="" || this.maeUsuarioE.x_nombres==null){
      this.utilitarioService.toastrError("Ingrese nombre del usuario.");
      return false;
    }

    if (this.maeUsuarioE.x_ape_pat=="" || this.maeUsuarioE.x_ape_pat==null){
      this.utilitarioService.toastrError("Ingrese apellido paterno del usuario.");
      return false;
    }

    if (this.maeUsuarioE.x_ape_mat=="" || this.maeUsuarioE.x_ape_mat==null){
      this.utilitarioService.toastrError("Ingrese apellido materno del usuario.");
      return false;
    }

    if (this.maeUsuarioE.c_oficina==0 || this.maeUsuarioE.c_oficina==null){
      this.utilitarioService.toastrError("Seleccione el organo del usuario.");
      return false;
    }

    if (this.maeUsuarioE.c_perfil==0 || this.maeUsuarioE.c_perfil==null){
      this.utilitarioService.toastrError("Seleccione el perfil del usuario.");
      return false;
    }

    if (this.maeUsuarioE.c_estado==0 || this.maeUsuarioE.c_estado==null){
      this.utilitarioService.toastrError("Seleccione el estado.");
      return false;
    }

    //valida tipo de comprobante
    return true;

  }

}
